import { shouldInitFacebookPixel } from './trackingRuntime';

const FACEBOOK_PIXEL_ID = '724704450653989';

/** Initializes Facebook Pixel on web builds only. */
export function initFacebookPixel() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (!shouldInitFacebookPixel()) return;

  try {
    const win = window as any;
    if (win.fbq) return;

    const fbq = function (...args: any[]) {
      if (typeof (fbq as any).callMethod === 'function') {
        (fbq as any).callMethod.apply(fbq, args);
      } else {
        (fbq as any).queue.push(args);
      }
    } as any;

    win.fbq = fbq;
    if (!win._fbq) win._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }

    window.fbq('init', FACEBOOK_PIXEL_ID);
    window.fbq('track', 'PageView');
  } catch (fbError) {
    console.warn('Facebook Pixel failed to load:', fbError);
  }
}
